import script from "./TemplateSelectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateSelectDialog.vue?vue&type=script&setup=true&lang=js"

import "./TemplateSelectDialog.vue?vue&type=style&index=0&id=60f54292&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f54292"]])

export default __exports__